import { React, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
//import axios from 'axios';

import api from '../api/api';

const handleGoogleLogin = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/google/url`);
    window.location.href = response.data.url;
  } catch (error) {
    console.error('Error initiating Google login:', error);
    // Handle error appropriately
  }
};

export default function SignUp({ onCancel, onSignInClick, onSignUpSuccess, language }) {
  const [showInfoMessage, setShowInfoMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [message, setMessage] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/register`, {
        email: data.get('email'),
        password: data.get('password'),
        language: language,
      });

      setMessage(response.data.message)

      if (response.data.success) {
        setShowInfoMessage(true);
        setTimeout(() => {
          setShowInfoMessage(false);
          onSignUpSuccess();
        }, 2000);

      } else {

        setShowErrorMessage(true);
        setTimeout(() => {
          setShowErrorMessage(false);
        }, 2000);
      }

    } catch (error) {
      setMessage(error.message)
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
      }, 2000);

    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {t('auth.signUp')}
          </Typography>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={handleGoogleLogin}
              sx={{ mb: 2 }}
            >
              Sign in with Google
            </Button>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label={t('auth.email')}
                  name="email"
                  autoComplete="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label={t('auth.password')}
                  type="password"
                  id="password"
                  autoComplete="new-password"
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {t('auth.signUp')}
            </Button>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={onCancel}
              sx={{ mb: 2 }}
            >
              {t('cancel')}
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link href="#" variant="body2" onClick={onSignInClick}>
                  {t('auth.alreadyHaveAccount')}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
      <Snackbar
        ContentProps={{
          style: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          },
        }}
        autoHideDuration={2000}
        open={showInfoMessage}
        onClose={() => setShowInfoMessage(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setShowInfoMessage(false)} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        ContentProps={{
          style: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          },
        }}
        autoHideDuration={2000}
        open={showErrorMessage}
        onClose={() => setShowErrorMessage(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setShowErrorMessage(false)} severity="error">
          {message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}
